import React__default, { useState, useMemo } from 'react';
import clsx from 'clsx';
import { C as Cross } from '../../Cross-2c127383.js';
import { S as SlideLeftTransition } from '../../SlideLeftTransition-22f36800.js';
import { u as useMediaQuery } from '../../useMediaQuery-f31e69fd.js';
import { u as useTheme } from '../../useTheme-923b5048.js';
import { u as useEscButton } from '../../useEscButton-73ea94fa.js';
import { a as ProfileMenuDesktopOverlay, b as ProfileMenuDesktopDropDownWrapper, o as StyledCollapsePannel, m as ProfileMenuList, n as ProfileMenuListItem, f as StyledProfileMenuListItemLink, P as ProfileMenuWrapper, c as ProfileMenuHeader, i as ProfileMenuHeaderImg, h as ProfileMenuHeaderTitleWrapper, j as ProfileMenuHeaderUserName, k as ProfileMenuHeaderSteps, l as ProfileMenuHeaderCloseButtonWrapper, S as SignedOutMenuHeader, B as BasicButton, p as StyledCollapse, d as SignOutButtonWrapper, e as SignOutButton, q as StyledArrowRight, g as StyledProfileMenuHeaderLink } from '../../ProfileMenuSidebar.styles-ea026f74.js';
import '../../SvgIcon-f1131561.js';
import '../../_tslib-4c7d6ae2.js';
import 'lodash/debounce';
import 'react-swipeable';
import 'react-transition-group';
import '../../useHistoryBack-a0e15180.js';
import '../../usePreventScroll-9ab469ed.js';
import 'body-scroll-lock';
import 'styled-components';
import '../../SlideStyles-8cb1c71e.js';
import '../../variables-80f55df9.js';
import 'rc-collapse';
import '../../ArrowRight-f839e372.js';

var DEFAULT_LINK_URL = "#";
function getClasses(_a) {
    var menuOptionItem = _a.menuOptionItem, routerPathname = _a.routerPathname;
    function isCurrentPath() {
        if (routerPathname === undefined || menuOptionItem.realPath === undefined) {
            return false;
        }
        return routerPathname === menuOptionItem.realPath;
    }
    return clsx({
        "--first": menuOptionItem.level === 0,
        "--second-level": menuOptionItem.level === 1,
        "--currentPath": isCurrentPath(),
    });
}
function checkIsCollapsiblePanelCurrentPath(_a) {
    var menuOptionItem = _a.menuOptionItem, routerPathname = _a.routerPathname;
    return routerPathname === menuOptionItem.realPath;
}
function profileMenuOptionItemHasContents(menuOptionItem) {
    if (Array.isArray(menuOptionItem.contents) && menuOptionItem.contents.length > 0) {
        return true;
    }
    return false;
}
var ExpandIcon = function (_a) {
    var isActive = _a.isActive;
    var classes = clsx({
        "--small": true,
        rotate: isActive,
    });
    return (React__default.createElement("div", { className: "collapsible-header-icon", "data-testid": "collapsible-group-icon" },
        React__default.createElement(StyledArrowRight, { className: classes })));
};
var getCollapsedHeight = function () { return ({ height: 0, opacity: 0 }); };
var getRealHeight = function (node) { return ({ height: node.scrollHeight, opacity: 1 }); };
var getCurrentHeight = function (node) { return ({ height: node.offsetHeight }); };
var skipOpacityTransition = function (_, event) { return event.propertyName === "height"; };
var collapseMotion = {
    motionName: "rc-collapse-motion",
    onEnterStart: getCollapsedHeight,
    onEnterActive: getRealHeight,
    onLeaveStart: getCurrentHeight,
    onLeaveActive: getCollapsedHeight,
    onEnterEnd: skipOpacityTransition,
    onLeaveEnd: skipOpacityTransition,
    motionDeadline: 500,
    leavedClassName: "rc-collapse-content-hidden",
};
var ProfileMenuLink = function (_a) {
    var text = _a.text, url = _a.url, onClick = _a.onClick, WrapperComponent = _a.WrapperComponent;
    var href = url || DEFAULT_LINK_URL;
    return (React__default.createElement(WrapperComponent, { "data-testid": "miTiendeo_link", 
        // fix for: https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#deprecating-javascript-urls
        href: href, onClick: function (event) {
            event.stopPropagation();
            // Prevent the link being followed and scrolling up to the top of the page
            // if using an onClick prop without an `url`
            if (href === DEFAULT_LINK_URL) {
                event.preventDefault();
            }
            if (typeof onClick === "function") {
                onClick(event);
            }
        } }, text));
};
var PanelHeader = function (_a) {
    var text = _a.text, url = _a.url, onClick = _a.onClick;
    return (React__default.createElement("div", { className: "collapsible-header-text" },
        React__default.createElement(ProfileMenuLink, { WrapperComponent: StyledProfileMenuHeaderLink, text: text, url: url, onClick: onClick })));
};
var ProfileMenuComponentDesktopWrapper = function (_a) {
    var menuOptions = _a.menuOptions, _b = _a.Texts, Texts = _b === void 0 ? {
        LOGIN_TEXT: "",
        LABEL_LOGOUT: "",
        USER_NAME: "",
        PROFILE_STEPS_COMPLETION: "",
    } : _b, isVisible = _a.isVisible, login = _a.login, logout = _a.logout, isLogged = _a.isLogged, profileImgUrl = _a.profileImgUrl, router = _a.router, onUserNameClick = _a.onUserNameClick, activeHeader = _a.activeHeader, onClose = _a.onClose, isMatchingMediaQuery = _a.isMatchingMediaQuery, activeGroup = _a.activeGroup;
    useEscButton(onClose, isVisible);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(ProfileMenuDesktopOverlay, { "data-testid": "backdrop", onClick: onClose }),
        React__default.createElement(ProfileMenuDesktopDropDownWrapper, null,
            React__default.createElement(ProfileMenuComponent, { menuOptions: menuOptions, Texts: Texts, login: login, logout: logout, isLogged: isLogged, profileImgUrl: profileImgUrl, router: router, onUserNameClick: onUserNameClick, activeHeader: activeHeader, isMatchingMediaQuery: isMatchingMediaQuery, activeGroup: activeGroup, onClose: onClose }))));
};
/**
 * We are using rc-collapse as the library to handle the collapsible elements
 * It uses an array with a string that identifies the current active element
 *
 * For the "profile" group the ['1'] index is used
 * For the "cashback" group the ['2'] index is used
 *
 * We use the "1" index and not any other because the "profile" group
 * has the "1" index in the array created by "menuOptions.map()".
 *
 * We use the "2" index and not any other because the "cashback" group
 * has the "2" index in the array created by "menuOptions.map()".
 *
 * If we want cashback to be the element with the index "4" in the array,
 * we will need to update the `cashback: ["4"]` property if it has
 * that position in the array.
 *
 * Examples from the `rc-collapse` docs
 * @see: https://github.com/react-component/collapse/blob/ea1ab9196e8721e90cd40af8a82a950d4b7dab06/examples/simple.tsx
 * @see: http://react-component.github.io/collapse/?path=/story/rc-collapse--simple
 */
var PROFILE_MENU_ACTIVE_GROUP_IDS = {
    profile: ["1"],
    cashback: ["2"],
};
function mapProfileMenuActiveGroupKeyNames(activeGroup) {
    if (activeGroup && PROFILE_MENU_ACTIVE_GROUP_IDS.hasOwnProperty(activeGroup)) {
        return PROFILE_MENU_ACTIVE_GROUP_IDS[activeGroup];
    }
    return ["0"];
}
var ProfileMenuComponent = function (_a) {
    var menuOptions = _a.menuOptions, _b = _a.Texts, Texts = _b === void 0 ? {
        LOGIN_TEXT: "",
        LABEL_LOGOUT: "",
        USER_NAME: "",
        PROFILE_STEPS_COMPLETION: "",
    } : _b, login = _a.login, logout = _a.logout, isLogged = _a.isLogged, profileImgUrl = _a.profileImgUrl, router = _a.router, onUserNameClick = _a.onUserNameClick, activeHeader = _a.activeHeader, isMatchingMediaQuery = _a.isMatchingMediaQuery, activeGroup = _a.activeGroup, onClose = _a.onClose;
    var showLogoutButton = isLogged && typeof logout === "function" && Boolean(Texts.LABEL_LOGOUT);
    var showLogin = typeof login === "function";
    var _c = useState(function () {
        /**
         * This is to indicate which collapsible rc-collapse group is currently active
         */
        return mapProfileMenuActiveGroupKeyNames(activeGroup);
    }), activeKey = _c[0], setActivekey = _c[1];
    var CollapsibleListItems = useMemo(function () {
        var mappedMenuOptions = menuOptions.map(function (menuOptionItem, index) {
            if (!profileMenuOptionItemHasContents(menuOptionItem)) {
                return;
            }
            if (!menuOptionItem.isVisible) {
                return;
            }
            var isCollapsiblePanelCurrentPath = checkIsCollapsiblePanelCurrentPath({
                menuOptionItem: menuOptionItem,
                routerPathname: router.pathname,
            });
            return (React__default.createElement(StyledCollapsePannel
            // The `Pannel` component from rc-collapse can receive a key prop
            // that identifies the current active collapsible group
            // This is tied to the `activeKey` prop on the `Collapse` component
            // also from the rc-collapse library
            , { 
                // The `Pannel` component from rc-collapse can receive a key prop
                // that identifies the current active collapsible group
                // This is tied to the `activeKey` prop on the `Collapse` component
                // also from the rc-collapse library
                key: index, isCollapsiblePanelCurrentPath: isCollapsiblePanelCurrentPath, className: getClasses({
                    menuOptionItem: menuOptionItem,
                    routerPathname: router.pathname,
                }), header: React__default.createElement(PanelHeader, { text: menuOptionItem.text, url: menuOptionItem.url, onClick: menuOptionItem.onClick }) },
                React__default.createElement(ProfileMenuList, null, menuOptionItem &&
                    menuOptionItem.contents &&
                    menuOptionItem.contents.map(function (item, index) {
                        return (React__default.createElement(ProfileMenuListItem, { key: index, className: getClasses({
                                menuOptionItem: item,
                                routerPathname: router.pathname,
                            }) },
                            React__default.createElement(ProfileMenuLink, { WrapperComponent: StyledProfileMenuListItemLink, text: item.text, url: item.url, onClick: item.onClick })));
                    }))));
        });
        return mappedMenuOptions.filter(Boolean);
    }, [menuOptions]);
    var NonCollapsibleListItems = useMemo(function () {
        var mappedMenuOptions = menuOptions.map(function (menuOptionItem, index) {
            if (profileMenuOptionItemHasContents(menuOptionItem) || menuOptionItem.isLanding) {
                return;
            }
            if (!menuOptionItem.isVisible) {
                return;
            }
            return (React__default.createElement(ProfileMenuListItem, { key: index, className: getClasses({ menuOptionItem: menuOptionItem, routerPathname: router.pathname }) },
                React__default.createElement(ProfileMenuLink, { WrapperComponent: StyledProfileMenuListItemLink, text: menuOptionItem.text, url: menuOptionItem.url, onClick: menuOptionItem.onClick })));
        });
        return mappedMenuOptions.filter(Boolean);
    }, [menuOptions]);
    var TiendeoLandingListItem = useMemo(function () {
        var mappedMenuOptions = menuOptions.map(function (menuOptionItem, index) {
            if (!menuOptionItem.isLanding || !menuOptionItem.isVisible) {
                return;
            }
            return (React__default.createElement(ProfileMenuListItem, { key: index, className: getClasses({ menuOptionItem: menuOptionItem, routerPathname: router.pathname }) },
                React__default.createElement(ProfileMenuLink, { WrapperComponent: StyledProfileMenuListItemLink, text: menuOptionItem.text, url: menuOptionItem.url, onClick: menuOptionItem.onClick })));
        });
        return mappedMenuOptions.filter(Boolean);
    }, [menuOptions]);
    var onClickCloseButton = function (e) {
        e.stopPropagation();
        onClose();
    };
    return (React__default.createElement(ProfileMenuWrapper, { fullHeight: !isMatchingMediaQuery, "data-testid": "miTiendeo_dropdown" },
        showLogin && (isLogged ? (React__default.createElement(ProfileMenuHeader, { activeHeader: activeHeader, className: "--log", onClick: onUserNameClick },
            React__default.createElement(ProfileMenuHeaderImg, { src: profileImgUrl }),
            React__default.createElement(ProfileMenuHeaderTitleWrapper, null,
                React__default.createElement(ProfileMenuHeaderUserName, null, Texts.USER_NAME),
                React__default.createElement(ProfileMenuHeaderSteps, null, Texts.PROFILE_STEPS_COMPLETION)),
            React__default.createElement(ProfileMenuHeaderCloseButtonWrapper, { onClick: onClickCloseButton },
                React__default.createElement(Cross, { className: "--small" })))) : (React__default.createElement(SignedOutMenuHeader, { className: "--out" },
            React__default.createElement(BasicButton, { onClick: login, "data-testid": "miTiendeoLogin_button" }, Texts.LOGIN_TEXT)))),
        React__default.createElement("section", null,
            React__default.createElement(ProfileMenuList, null,
                TiendeoLandingListItem,
                CollapsibleListItems.length > 0 && (React__default.createElement(StyledCollapse, { openMotion: collapseMotion, expandIcon: ExpandIcon, activeKey: activeKey, accordion: true, onChange: function (currentKey) { return setActivekey([currentKey]); } }, CollapsibleListItems)),
                NonCollapsibleListItems)),
        showLogoutButton && (React__default.createElement(SignOutButtonWrapper, null,
            React__default.createElement(SignOutButton, { className: "--logout", "data-testid": "miTiendeoLogout_button", onClick: logout },
                React__default.createElement("span", null, Texts.LABEL_LOGOUT))))));
};
var ProfileMenuSidebar = function (_a) {
    var menuOptions = _a.menuOptions, _b = _a.Texts, Texts = _b === void 0 ? {
        LOGIN_TEXT: "",
        LABEL_LOGOUT: "",
        USER_NAME: "",
        PROFILE_STEPS_COMPLETION: "",
    } : _b, isVisible = _a.isVisible, login = _a.login, logout = _a.logout, isLogged = _a.isLogged, profileImgUrl = _a.profileImgUrl, onClose = _a.onClose, router = _a.router, onUserNameClick = _a.onUserNameClick, closeOnBackButton = _a.closeOnBackButton, activeHeader = _a.activeHeader, activeGroup = _a.activeGroup;
    var theme = useTheme();
    var isMatchingMediaQuery = useMediaQuery("(min-width: ".concat(theme.layout.breakpoints.xs, ")"));
    if (isMatchingMediaQuery && !isVisible) {
        return null;
    }
    if (isMatchingMediaQuery && isVisible) {
        return (React__default.createElement(ProfileMenuComponentDesktopWrapper, { menuOptions: menuOptions, Texts: Texts, login: login, logout: logout, isLogged: isLogged, profileImgUrl: profileImgUrl, router: router, onUserNameClick: onUserNameClick, activeHeader: activeHeader, isMatchingMediaQuery: isMatchingMediaQuery, isVisible: isVisible, onClose: onClose, activeGroup: activeGroup }));
    }
    return (React__default.createElement(SlideLeftTransition, { isVisible: isVisible, onClose: onClose, duration: 300, showCloseButton: false, Variant: "--profile-menu", closeOnBackButton: closeOnBackButton, hideOverlay: isMatchingMediaQuery },
        React__default.createElement(ProfileMenuComponent, { menuOptions: menuOptions, Texts: Texts, login: login, logout: logout, isLogged: isLogged, profileImgUrl: profileImgUrl, router: router, onUserNameClick: onUserNameClick, activeHeader: activeHeader, isMatchingMediaQuery: isMatchingMediaQuery, activeGroup: activeGroup, onClose: onClose })));
};

export { ProfileMenuSidebar as default };
//# sourceMappingURL=ProfileMenuSidebar.js.map
